"use client";

import { use } from "react";
import Link from "next/link";
import { useQuery } from "@tanstack/react-query";
import { PostFeed } from "../../_modules/components/PostFeed";
import { StickyRail } from "../../_modules/components/StickyRail";
import { CategoryRail } from "../../_modules/components/ForumChrome";
import { forumService, forumPath } from "../../_modules/components/ForumService";
import { CategoryIconTile } from "../../_modules/components/categoryIcons";
import { NewPostButton } from "../../_modules/components/NewPostButton";

export default function ForumCategoryPage({ params }: { params: Promise<{ category: string }> }) {
  const { category } = use(params);
  const { data: categories } = useQuery({
    queryKey: ["forum", "categories"],
    queryFn: forumService.getCategories,
    staleTime: 10 * 60_000,
  });
  const cat = categories?.find((c) => c.slug === category);

  return (
    <div className="flex gap-6">
      <aside className="hidden w-52 shrink-0 lg:block">
        <StickyRail>
          <p className="px-2 pb-2 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">Rooms</p>
          <CategoryRail activeSlug={category} />
        </StickyRail>
      </aside>
      <main className="min-w-0 flex-1">
        <nav className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted-foreground" aria-label="Breadcrumb">
          <Link href={forumPath()} className="hover:text-primary">Community</Link>
          <span className="mx-1">/</span>
          <span className="text-foreground/80">{cat?.name || "…"}</span>
        </nav>
        {cat && (
          <div className="mb-3 mt-1 flex items-start gap-3">
            <CategoryIconTile slug={cat.slug} size="lg" active />
            <div className="min-w-0 flex-1">
              <h1 className="forum-serif text-[22px] font-medium leading-tight text-foreground">{cat.name}</h1>
              {cat.description && <p className="mt-0.5 text-[13px] text-muted-foreground">{cat.description}</p>}
            </div>
            <NewPostButton categorySlug={cat.slug} className="shrink-0 self-center" />
          </div>
        )}
        <PostFeed categorySlug={category} categoryName={cat?.name} title={cat ? `Threads in ${cat.name}` : undefined} />
      </main>
    </div>
  );
}
